module.exports = __webpack_public_path__ + "static/Skyway_Multispectral_Imaging-501ae015366951944b6987cf42f9efa0.png";